import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FieldList } from 'components';

class Default extends Component {
  render() {
    return (
      <div>
        <FieldList
          {...this.props}
          fields={[
            
          ]}
        />
      </div>
    );
  }
}

export default Default;



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/templates/pages/default.js